import { render, staticRenderFns } from "./ProfileFilling.vue?vue&type=template&id=bb2675f0"
import script from "./ProfileFilling.vue?vue&type=script&lang=js"
export * from "./ProfileFilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports